import { z } from "zod";
import { bidCreateSchema, holdRequestSchema, orderCreateSchema } from "./orderSchemas";

const quantityFromForm = z.coerce.number().int().positive();
const moneyFromForm = z.coerce.number().positive();
const holdHoursFromForm = z.coerce.number().int().min(1).max(72);
const shipToSchema = z.string().min(5, "Ship to is required");

export const checkoutBuyNowSchema = orderCreateSchema.extend({
  action: z.literal("buy"),
  quantity: quantityFromForm,
  shipTo: shipToSchema,
});

export const checkoutBidSchema = bidCreateSchema.extend({
  action: z.literal("bid"),
  quantity: quantityFromForm,
  unitPrice: moneyFromForm,
  shipTo: shipToSchema,
});

export const checkoutHoldSchema = holdRequestSchema.extend({
  action: z.literal("hold"),
  quantity: quantityFromForm,
  holdHours: holdHoursFromForm,
  shipTo: shipToSchema,
});

export const checkoutFormSchema = z.discriminatedUnion("action", [checkoutBuyNowSchema, checkoutBidSchema, checkoutHoldSchema]);

export type CheckoutAction = z.infer<typeof checkoutFormSchema>["action"];
export type CheckoutBuyNowInput = z.input<typeof checkoutBuyNowSchema>;
export type CheckoutBidInput = z.input<typeof checkoutBidSchema>;
export type CheckoutHoldInput = z.input<typeof checkoutHoldSchema>;
export type CheckoutFormInput = z.input<typeof checkoutFormSchema>;
export type CheckoutFormData = z.infer<typeof checkoutFormSchema>;
